import React from 'react'
import logo from '../../../assets/static/logo-milum.png'

const LogotipoMilum = () => <img src={logo} alt="Logotipo Milum" />

export default LogotipoMilum
